import { createClient } from '@supabase/supabase-js'
import { tabSessionStorage, tabStorageKey } from './tabSessions'
import { viewModeFetch } from './viewMode'

/**
 * The Supabase client, and the only place it is created.
 *
 * The URL and anon key are not secrets:
 * they ship to every browser that loads the app, and what a request may do is
 * decided entirely by the row-level security policies in supabase/rls.sql. The
 * key that must never appear here, or anywhere in the bundle, is
 * `service_role`, which bypasses those policies altogether. It lives in Edge
 * Function secrets and nowhere else.
 */
const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

/**
 * Whether Supabase is configured at all.
 *
 * A checkout without a .env has no credentials. Anything reaching for the
 * client must check this first.
 */
export const supabaseConfigured = Boolean(url && anonKey)

/** "ohbpbbguusblcmfzcykt" in https://ohbpbbguusblcmfzcykt.supabase.co */
const projectRef = supabaseConfigured ? new URL(url).hostname.split('.')[0] : ''
const storageKey = tabStorageKey(projectRef)
const authStorage = tabSessionStorage(storageKey, `sb-${projectRef}-auth-token`)

/**
 * Bu sekmede girmiş kişinin kimliği, ağ beklemeden (28 Eki 2026). Açılışta
 * kayıtlı oturum kopyasını hemen göstermek için; doğrulama arkadan geliyor.
 */
export function storedUserId(): string | null {
  try {
    const raw = authStorage.getItem(storageKey)
    const id = raw ? (JSON.parse(raw) as { user?: { id?: string } }).user?.id : null
    return typeof id === 'string' && id ? id : null
  } catch {
    return null
  }
}

export const supabase = supabaseConfigured
  ? createClient(url, anonKey, {
      auth: {
        // Her sekme kendi hesabıyla; bkz. tabSessions.ts. Eski tek anahtar
        // yalnızca bir kez, taşımak için okunuyor.
        storageKey,
        storage: authStorage,
        // The till is a shared machine that stays logged in for a whole
        // service; a session that quietly expired mid-service would mean a
        // cashier discovering it at the counter with a queue waiting.
        persistSession: true,
        autoRefreshToken: true,
        // Owners now do arrive by link: an invitation to a new institution and
        // a password reset both land here carrying a token in the URL, and
        // without this the link would open an ordinary signed-out page. Staff
        // still sign in with a name and a PIN and never see one.
        detectSessionInUrl: true,
      },
      // Postgres changes drive the live views. The default is generous for a
      // dozen tills in one restaurant; raising it costs nothing but memory.
      realtime: { params: { eventsPerSecond: 20 } },
      // Görüntüleme modunda yazma istekleri burada duruyor (viewMode.ts).
      global: { fetch: viewModeFetch },
    })
  : // Deliberately null rather than a stub. A stub would let a missing
    // configuration reach production and fail as "nothing happens", which is
    // exactly the class of bug the undefined-note incident taught us to avoid.
    null
